const images = {
  armstrongWatson: require('./armstrong-watson.png'),
  balanceSheetIntro: require('./balance-sheet-intro.png'),
  balanceSheetPlaceholder: require('./balance-sheet-upsell-placeholder.png'),
  facilityPlaceholder: require('./facility-upsell-placeholder.png'),
  bdo: require('./bdo.png'),
  businessSupportGuide: require('./business-support-guide.png'),
  businessSupportGuideSmall: require('./business-support-guide-small.png'),
  capitalAdvisory: require('./capital-advisory.jpg'),
  capitaliseDemo: require('./capitalise-demo.png'),
  capitaliseGetStarted: require('./capitalise-get-started.png'),
  capitaliseMedia: require('./capitalise-logo.png'),
  capitaliseCLogo: require('./capitalise-c-logo.png'),
  capitalisePlaybook: require('./capitalise-playbook.png'),
  capitaliseTeam: require('./capitalise-team.png'),
  chats: require('./chats.png'),
  experianLogo: require('./experian-logo.png'),
  flinder: require('./flinder.png'),
  getStarted: require('./get-started.png'),
  graemeTennick: require('./graeme-tennick.png'),
  healthReportCard: require('./health-report-card.png'),
  howDoesItWork: require('./how-does-it-work.png'),
  lenderMarket: require('./lender_market.png'),
  mediaPack: require('./capitalise-media-pack.png'),
  moodysLogo: require('./moodys-logo.png'),
  offerExample: require('./offer-example.png'),
  pkf: require('./pkf.png'),
  playbookBooklets: require('./playbook/booklets.png'),
  playbookLearn: require('./playbook/learn.png'),
  playbookMedia: require('./playbook/playbook.png'),
  proMembershipBadge: require('./pro-membership-badge.png'),
  reportCard: require('./report-card.png'),
  soaringFalcon: require('./soaring-falcon.png'),
  startLearning: require('./start-learning.png'),
  videoThumbnail: require('./video-thumbnail.jpg'),
};

export default images;
